import { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { PartnerSidebar } from './PartnerSidebar'
import { NotificationPanel } from '../ui/NotificationPanel'
import { Menu } from 'lucide-react'

export function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 1024
      setIsMobile(mobile)
      if (mobile) {
        setSidebarOpen(false)
      }
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const handleToggle = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const closeSidebar = () => {
    if (isMobile) {
      setSidebarOpen(false)
    }
  }

  return (
    <div className="main-layout">
      {/* Mobile Header */}
      {isMobile && (
        <header className="mobile-header">
          <button
            className="mobile-menu-btn"
            onClick={handleToggle}
            aria-label="Toggle menu"
          >
            <Menu size={24} />
          </button>
          <div className="mobile-logo">
            <span className="mobile-logo-text">Partner Admin</span>
          </div>
          <div style={{ width: '40px' }} />
        </header>
      )}

      {/* Partner Sidebar */}
      <PartnerSidebar
        isOpen={sidebarOpen}
        onToggle={handleToggle}
        isMobile={isMobile}
        onNavigate={closeSidebar}
      />

      {/* Main content */}
      <div
        className="main-content"
        style={{
          marginLeft: isMobile ? 0 : (sidebarOpen ? '260px' : '70px'),
          marginTop: isMobile ? '60px' : 0
        }}
      >
        <main className="content-area" id="main-content" role="main" aria-label="Conteúdo principal">
          <div className="flex justify-end mb-4">
            <NotificationPanel />
          </div>
          <div className="fade-in">
            <Outlet />
          </div>
        </main>
      </div>

      <style>{`
        .main-layout {
          display: flex;
          min-height: 100vh;
          background: #f9fafb;
          position: relative;
          transition: background-color 0.3s ease;
        }

        :root.dark .main-layout {
          background: hsl(222.2 84% 4.9%);
        }

        .mobile-header {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: 60px;
          background: #ffffff;
          border-bottom: 1px solid #e5e7eb;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 1rem;
          z-index: 40;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          transition: background-color 0.3s ease, border-color 0.3s ease;
        }

        :root.dark .mobile-header {
          background: hsl(222.2 84% 6%);
          border-color: hsl(217.2 32.6% 17.5%);
        }

        .mobile-menu-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: #f1f5f9;
          border: none;
          border-radius: 8px;
          color: #374151;
          cursor: pointer;
          transition: all 0.2s;
        }

        :root.dark .mobile-menu-btn {
          background: hsl(217.2 32.6% 17.5%);
          color: #d1d5db;
        }

        .mobile-menu-btn:hover {
          background: #e2e8f0;
        }

        :root.dark .mobile-menu-btn:hover {
          background: hsl(217.2 32.6% 22%);
        }

        .mobile-menu-btn:active {
          transform: scale(0.95);
        }

        .mobile-logo {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .mobile-logo-text {
          font-size: 1.125rem;
          font-weight: 700;
          color: #10b981;
        }

        .main-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          transition: margin-left 0.3s ease;
          width: 100%;
          min-width: 0;
        }

        .content-area {
          flex: 1;
          padding: 1.5rem;
          overflow-x: hidden;
          overflow-y: auto;
          background: #f9fafb;
          transition: background-color 0.3s ease;
        }

        :root.dark .content-area {
          background: hsl(222.2 84% 4.9%);
        }

        .fade-in {
          animation: fadeIn 0.3s ease-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Tablet adjustments */
        @media (max-width: 1024px) {
          .content-area {
            padding: 1rem;
          }
        }

        /* Mobile adjustments */
        @media (max-width: 768px) {
          .content-area {
            padding: 0.75rem;
          }
        }

        @media (max-width: 480px) {
          .content-area {
            padding: 0.5rem;
          }
        }
      `}</style>
    </div>
  )
}
